export const UNSAVED_VIEW_ID = '__UNSAVED_VIEW__';
